module.exports = __webpack_public_path__ + "img/15.a0f2bf60.svg";